// extracted by mini-css-extract-plugin
module.exports = {"products":"IV","productContainer":"JV","overFlowVisible":"KV","resultsHeading":"LV","oosMessaging":"MV","bestExp":"NV","bestExpRecognized":"OV","bestExpMobile":"PV"};